import React, { Component } from 'react'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import Footer from '@sainsburys-tech/bolt-footer'
import * as Styled from './Footer.styles'

const BRAND = process.env.BRAND || 'ARGOS'

class PDPFooter extends Component {
  constructor(props) {
    super(props)

    // this improves time to visually complete by stopping images and SVG assets
    // in the footer being requested until React initialised on the clientside
    this.state = {
      collapsedFooter: true
    }
  }

  componentDidMount() {
    const onPDPV2 = document.querySelector('.pdp-v2-main')
    this.setState({
      collapsedFooter: false,
      onPDPV2: !!onPDPV2
    })
  }

  getFooter = () => {
    if (BRAND === 'TU') {
      return null
    }
    if (this.state.collapsedFooter) {
      if (BRAND === 'HABITAT') {
        return <Footer brand='habitat' navigationHidden gridHidden brandHidden legalHidden />
      }
      return <Footer brand='argos' navigationHidden gridHidden brandHidden legalHidden />
    }
    if (BRAND === 'HABITAT') {
      return <Footer brand='habitat' navigationHidden paypalCreditHidden={false} />
    }
    return <Footer brand='argos' navigationHidden paypalCreditHidden={false} />
  }

  render() {
    return (
      <ErrorBoundary>
        <Styled.Footer addBottomPadding={this.state.onPDPV2} className='container--footer'>
          {this.getFooter()}
        </Styled.Footer>
      </ErrorBoundary>
    )
  }
}

export default PDPFooter
